module.exports = __webpack_public_path__ + "img/damac.ec4b3c3.svg";